<template>
  <div class="register footer-margin">
    <Breadcrumb />

    <div class="container">
      <div id="register-row" class="row justify-content-center align-items-center">
        <div id="register-column" class="col-lg-6 col-md-6 col-sm-8 col-12">
          <div id="register-box" class="col-12">
            <form>
              <h3 class="text-center text-info">Registrieren</h3>


              <div class="text-center mb30">Erstelle jetzt ganz einfach ein Profil und erhalte Kultur-Empfehlungen, lege Merklisten an und vieles mehr!</div>

              <div class="form-group">
                <div class="inner-addon left-addon">
                  <i class="glyphicon material-icons icon" aria-hidden="true">person</i>
                  <input type="text" class="form-control"  @blur="validateNameInput" v-model="credentials.name" placeholder="Vor- und Nachname"/>
                </div>
                <span class="validation-error" v-show="showNameError">Geben Sie Ihren Vor- und Nachnamen ein.</span>
              </div>

              <div class="form-group">
                <div class="inner-addon left-addon">
                  <i class="glyphicon material-icons icon" aria-hidden="true">email</i>
                  <input type="text" class="form-control" @blur="validateEmailInput(), checkIfExists()" v-model="credentials.email" placeholder="E-Mail"/>
                </div>
                <span class="validation-error" v-show="showEmailExistsError">Es gibt bereits einen Account mit dieser E-Mail Adresse.</span>
                <span class="validation-error" v-show="showEmailError">Geben Sie Ihre E-Mail Adresse an.</span>
              </div>

              <div class="form-group mb-2">
                <div class="inner-addon left-addon">
                  <i class="glyphicon material-icons icon" aria-hidden="true">lock</i>
                  <input type="password" class="form-control"  @blur="validatePasswordInput" v-model="credentials.password" placeholder="Passwort"/>
                </div>
                <span class="validation-error" v-show="showPasswordError">Geben Sie ein Passwort ein. Beachten Sie dabei die unten genannten Anforderungen.</span>
              </div>

              <div class="mb-2 pw-req">Mindestens 8 Zeichen, 1 Großbuchstabe, 1 Kleinbuchstabe, 1 Zahl</div>

              <div class="form-group">
                <div class="inner-addon left-addon">
                  <i class="glyphicon material-icons icon" aria-hidden="true">lock</i>
                  <input type="password" class="form-control"  @blur="validatePasswordRepeatInput" v-model="credentials.passwordRepeat" placeholder="Passwort wiederholen"/>
                  <span class="validation-error" v-show="showPasswordRepeatError">Die Passwörter stimmen nicht überein.</span>
                </div>
              </div>

              <div class="form-check">
                <div class="form-check checkbox">
                  <input class="input-style form-check-input" type="checkbox" tabindex="0" v-model="credentials.agbAccepted" id="dataSecurity" @change="checkBoxChanged">
                  <label class="form-check-label" for="dataSecurity">Ja, ich akzeptiere die <router-link target="_blank" class="datasec" :to="{ name: 'datenschutz'}">Datenschutzerklärung</router-link></label>
                </div>
                <span class="validation-error" style="margin-left: -20px;" v-show="showDataSecError">Sie müssen die Datenschutzerklärung akzeptieren.</span>
              </div>

              <div class="form-group">
                <button type="submit" @click="handleRegister" style="width: 100%;" class="btn btn-fill btn-focus-design" title="Neues Benutzerkonto anlegen">Registrieren</button>
              </div>

              <div class="register-row">
                <div class="text-center">Schon dabei?</div>
                <router-link class="btn mt20 btn-focus-design" style="width: 100%;" :to="{ name: 'login'}">
                  Anmelden
                </router-link>
              </div>

              <div class="anbieter-notice login-row">
                Sie sind ein*e Anbieter*in für Kultur in Kiel? 
                <a href="https://bildungsangebote-kiel.de">
                  Jetzt kostenlos registrieren & inserieren!
                </a>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Breadcrumb from '@/components/controls/Breadcrumb.vue';
  import { csrf, emailExists } from '@/api/auth';
  import { validEmail, validatePassword } from '@/utils/validate';
  import { handleCollectionInvitation } from '@/api/collection';
  import { showLoader, hideLoader } from '@/utils/helpers';
  import Resource from '@/api/resource';
  const userResource = new Resource('users');

  export default {
    name: 'Register',
    components: {
      Breadcrumb,
    },
    data() {
      return {
       credentials: {
        name: "",
        email: "",
        password: "",
        passwordRepeat: "",
        agbAccepted: false,
        appId: this.$appId,
        sharekey: null,
        appUrl: window.location.origin,
      },
      showEmailExistsError: false,
      showNameError: false,
      showEmailError: false,
      showPasswordError: false,
      showPasswordRepeatError: false,
      showDataSecError: false,
      loader: false,
    };
  },
  beforeCreate() {
    /*Collection Invitation ...*/
    if(this.$route.query.sharekey){

      handleCollectionInvitation(this.$route.query.sharekey).then( response => {
        /*save the institution*/
        this.credentials.sharekey = response.data;
        this.$notify({
          duration: 2500,
          title: 'Einladung annehmen',
          text: 'Registrieren Sie sich um die Einladung zu einer Merkliste anzunehmen.'
        });

      });
    }
  },
  methods: { 
    showLoader,
    hideLoader,
    validEmail,
    validatePassword,
    handleCollectionInvitation,
    checkBoxChanged(origin){
      this.$emit('checkBoxChanged', this.checked);
    },
    validateNameInput(){
      if(this.credentials.name == "" || this.credentials.name.length<4){
        this.showNameError = true;
        return false;
      }
      this.showNameError = false;
      return true;
    },
    validatePasswordInput(){
      if(!this.validatePassword(this.credentials.password)){
        this.showPasswordError=true;
        return false;
      }else{
        this.showPasswordError=false;
        return true;
      }
    },
    validatePasswordRepeatInput(){
      if(this.credentials.password != this.credentials.passwordRepeat){
        this.showPasswordRepeatError=true;
        return false;
      }else{
        this.showPasswordRepeatError=false;
        return true;
      }
    },
    validateEmailInput(){
      if(!validEmail(this.credentials.email)){
        this.showEmailError=true;
        return false;
      }
      else{
        this.showEmailError=false;
        return true;
      }
    },
    validateDataSecAccepted(){
      if(!this.credentials.agbAccepted){
        this.showDataSecError=true;
        return false;
      }
      else{
        this.showDataSecError=false;
        return true;
      }
    },
    checkIfExists(){
      var theMail = {email: this.credentials.email};
      emailExists(theMail).then(response => {
        if(response.status == "204"){
          /*no user*/
          this.showEmailExistsError = false;
        }
        else if(response.status == "200"){
          /*a user exists*/
          this.showEmailExistsError = true;
        }
      });
    },
    handleRegister(e) {
      e.preventDefault();
      var nameValid = this.validateNameInput();
      var emailValid = this.validateEmailInput();
      var passwordValid = this.validatePasswordInput();
      var passwordRepeatValid = this.validatePasswordRepeatInput();
      var dataSecurityAccepted = this.validateDataSecAccepted();
      if(!nameValid || !emailValid || !passwordValid || !passwordRepeatValid || this.showEmailExistsError || !dataSecurityAccepted){
        return;
      }

      this.loader = this.showLoader(this.loader);

      csrf().then(() => {
        userResource.store(this.credentials).then(() => {

          this.$notify({
            duration: 2500,
            title: 'Registrierung erfolgreich!',
            text: 'Ihre Registrierung im KulturKompass Kiel war erfolgreich.'
          });

          this.$router.push({name:'login', query: { afterRegistration: true }});

        })
        .catch(() => {
         this.$notify({
          type: 'error',
          duration: 2500,
          title: 'Registrierung fehlgeschlagen!',
          text: 'Die Registrierung ist fehlgeschlagen. Bitte probieren Sie es zu einem späteren Zeitpunk noch einmal!'
        });
       }).finally(()=>{
         this.loader = this.hideLoader(this.loader);
       });
     });
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/_variables.scss';

  .register {
    position: relative;
    background: #fff;
    padding-top: 110px;
    padding-bottom: 40px;

    .anbieter-notice{
      margin-top:30px; 
      text-align:center;

      a{
        color:#E30059;

        &:hover{
          color:#0d6efd;
        }
      }
    }

    .container {
      max-width: 1000px;

      #register-column{

        @media (max-width: 575px) {
          padding: 0px 50px;
        }

        @media (max-width: 400px) {
          padding: 0px 30px;
        }

      }


      h3.text-info {
        color: #00183E !important;
        margin-bottom: 30px;
      }

      .form-check{
        margin-bottom: 20px;      
      }

      .form-group {
        margin-bottom: 30px;

        @media (max-width: 575px) {
          margin-bottom: 20px;
        }

        .left-addon .glyphicon {
          left: 0px;
        }

        .inner-addon {
          position: relative;
        }

        .inner-addon .glyphicon {
          position: absolute;
          padding: 7px;
          pointer-events: none;
          color: #E30059;
        }

        .left-addon input {
          padding-left: 35px;
        }
      }
    }
  }
  .checkbox{
    width: 100%;
    
    label {
      position: relative;
      text-align: left;
      cursor: pointer;
      width: 100%;

      &:before{
        content: '';
        position: absolute;
        left: -40px;
        -webkit-appearance: none;
        width: 20px;
        height: 20px;
        border: 1px solid rgba(58, 58, 58, 0.2);
        display: inline-flex;
        margin-right: 20px;
      }

      &:after{
        content: '';
        display: block;
        position: absolute;
        top: 2px;
        left: 9px;
        width: 6px;
        height: 14px;
        border: solid #FFFFFF;
        border-top-width: medium;
        border-right-width: medium;
        border-bottom-width: medium;
        border-left-width: medium;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        left: -33px;
      }

    }

    input[type="checkbox"]{
      opacity: 0;

      &:focus-visible + label::before {
        border: 2px dashed #E30059 !important;
        border-radius: 3px !important;
        outline: none !important;
      }

      + label::after {
        content: none;
      }

      &:checked{ 

        + label::before {
          background-color: #FFF;
        }

        + label::after{
          content: '';
          display: block;
          position: absolute;
          top: 2px;
          left: 9px;
          width: 6px;
          height: 14px;
          border: solid #E30059;
          border-top-width: medium;
          border-right-width: medium;
          border-bottom-width: medium;
          border-left-width: medium;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
          left: -33px;
        }
      }
    }
  }

  .pw-req {
    font-size: 12px;
    line-height: 1.5;
  }
</style>
